import {
  FieldSection,
  FieldSectionTitle,
  FormContainer,
  FormRoleConfContext,
  FormTextField,
  useRoleConf,
} from "@pharmupp/p3-front-commons"
import { formRoleConf } from "./MyPharmacy.formRoleConf"
import { MyPharmacyEnum, type MyPharmacyFormValues } from "./MyPharmacy.schema"

export const MyPharmacy = () => {
  const conf = useRoleConf(formRoleConf)

  return (
    <FormRoleConfContext.Provider value={conf}>
      <FormContainer>
        <FieldSectionTitle title="Ma Pharmacie" />
        <FieldSection title="Nom" subtitle="Nom de l'officine">
          <FormTextField<MyPharmacyFormValues>
            label="Nom de l'officine"
            name={MyPharmacyEnum.NAME}
            required
          />
        </FieldSection>
      </FormContainer>
    </FormRoleConfContext.Provider>
  )
}
